import {PressReleaseInformationDownloadButton} from './download-button';
import {PressReleaseInformationFileDownload} from './file-download';
import {PressReleaseInformationPressKitLink} from './press-kit-link';
import {PressReleaseInformationRoot} from './root';
import {
  PressReleaseInformationDownloadRow,
  PressReleaseInformationTable,
} from './table';

export const pressReleaseInformation = {
  root: PressReleaseInformationRoot,
  table: PressReleaseInformationTable,
  downloadButton: PressReleaseInformationDownloadButton,
  pressKitLink: PressReleaseInformationPressKitLink,
  fileDownload: PressReleaseInformationFileDownload,
  downloadRow: PressReleaseInformationDownloadRow,
};
